import { Dispatch, SetStateAction, FC } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import "./Dropdown.scss";

interface IDropdownProps {
  dropdown: boolean;
  setDropdown: Dispatch<SetStateAction<boolean>>;
}

export const Dropdown: FC<IDropdownProps> = ({ dropdown, setDropdown }) => {
  let activePath = useLocation().pathname;
  return (
    <div className={`Dropdown ${dropdown ? "show" : ""}`}>
      <div className="Dropdown_links-wrapper">
        <div className="Dropdown_close">
          <i className="fa fa-times" onClick={() => setDropdown(false)}></i>
        </div>
        <div className="Dropdown_links">
          <ul>
            <li className={activePath === "/" ? "active" : ""}>
              <Link to="/" onClick={() => setDropdown(false)}>
                Home
              </Link>
            </li>
            <li className={activePath === "/about" ? "active" : ""}>
              <Link to="/about" onClick={() => setDropdown(false)}>
                About Us
              </Link>
            </li>
            <li className={activePath === "/solutions" ? "active" : ""}>
              <Link to="/solutions" onClick={() => setDropdown(false)}>
                Solutions
              </Link>
            </li>
            <li className={activePath === "/careers" ? "active" : ""}>
              <Link to="/careers" onClick={() => setDropdown(false)}>
                Careers
              </Link>
            </li>
            <li className={activePath === "/contract-vehicles" ? "active" : ""}>
              <Link to="/contract-vehicles" onClick={() => setDropdown(false)}>
                Contract Engagement
              </Link>
            </li>
            <li>
              <a href="/news">News and Awards</a>
            </li>
            <li>
              <a href="/contacts">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
